import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { me } from "./client.ts";
import { EmptyState, ErrorText, Feedback } from "./ui/index.ts";

export const Landing = () => {
  const meQuery = useQuery({ queryKey: ["me"], queryFn: me });

  if (meQuery.isLoading) return <Feedback>Loading…</Feedback>;
  if (meQuery.isError || !meQuery.data) return <ErrorText>Failed to load portal.</ErrorText>;

  const { name, nav } = meQuery.data;

  return (
    <div>
      <div className="page-head landing-head">
        <div>
          <h1 className="t-display">Welcome, {name}</h1>
          <p className="t-body t-muted">Choose where you want to go.</p>
        </div>
      </div>
      {nav.length === 0 ? (
        <EmptyState title="No sections available">You don't have access to any portal sections yet.</EmptyState>
      ) : (
        <div className="landing-menu">
          {nav.map((item) => (
            <section key={item.id} className="landing-menu__section" aria-labelledby={`landing-${item.id}`}>
              <div className="landing-menu__summary">
                <h2 id={`landing-${item.id}`} className="t-title">
                  <Link to={item.href} className="landing-menu__action">
                    <span className="landing-menu__action-label">{item.label}</span>
                    <span className="landing-menu__action-arrow" aria-hidden="true">
                      →
                    </span>
                  </Link>
                </h2>
                <p className="t-body-sm t-muted">{item.description}</p>
              </div>
              {item.children && (
                <nav className="landing-menu__links" aria-label={`${item.label} destinations`}>
                  {item.children.map((child) => (
                    <Link key={child.id} to={child.href} className="landing-menu__link">
                      <span className="t-label">{child.label}</span>
                      <span className="t-caption">{child.description}</span>
                    </Link>
                  ))}
                </nav>
              )}
            </section>
          ))}
        </div>
      )}
    </div>
  );
};
